<a class="change-draft-card" [routerLink]="detailUrl()" data-cy="investment-change-draft-card">
    <div class="change-draft-label">
        {{ 'investments.changeDraftCard.label' | translate }}
    </div>
    <div class="draft-card-layout">
        <div class="draft-card-header">
            <liberro-avatar-photo-tagged [portfolioDetail]="{ portfolioType: draft().portfolioManagementType }" size="44"></liberro-avatar-photo-tagged>
            <div class="name-wrapper">
                <div class="name" data-cy="investment-change-draft-card-name">
                    {{ draft().name }}
                </div>
            </div>
            <liberro-badge
                variant="danger"
                [label]="('investments.draftCard.expiresIn' | translate) + (draft().autoExpiryTime | dayDiff)"
                [unbreakable]="true"
                data-cy="investment-change-draft-card-expiry"
            ></liberro-badge>
        </div>
        <div class="detail-layout">
            <div class="detail-row">
                <div class="label">
                    {{ 'investments.draftCard.totalYearsToInvest' | translate }}
                </div>
                <div class="value" data-cy="investment-change-draft-card-years">
                    @if (totalYearsToInvest(); as parameter) {
                        <span class="before">{{ parameter.before | yearsTranslate }}</span>
                        {{ parameter.after | yearsTranslate }}
                    } @else {
                        {{ draft().totalYearsToInvest | yearsTranslate }}
                    }
                </div>
            </div>
            <div class="detail-row">
                <div class="label">
                    {{ 'investments.draftCard.initialDeposit' | translate }}
                </div>
                <div class="value" data-cy="investment-change-draft-card-initial-deposit">
                    @if (initialDeposit(); as parameter) {
                        <span class="before">{{ parameter.before | price }}</span>
                        {{ parameter.after | price }}
                    } @else {
                        {{ draft().initialDeposit | price }}
                    }
                </div>
            </div>
            <div class="detail-row">
                <div class="label">
                    {{ 'investments.draftCard.regularDeposit' | translate }}
                </div>
                <div class="value" data-cy="investment-change-draft-card-regular-deposit">
                    @if (regularDeposit(); as parameter) {
                        <span class="before">{{ parameter.before | price }}</span>
                        {{ parameter.after | price }}
                    } @else {
                        {{ draft().regularDeposit | price }}
                    }
                </div>
            </div>
            <div class="detail-row">
                <div class="label">
                    {{ 'investments.draftCard.weeksBetweenInvestments' | translate }}
                </div>
                <div class="value" data-cy="investment-change-draft-card-frequency">
                    @if (weeksBetweenInvestments(); as parameter) {
                        <span class="before">{{ ('newInvestment.settings.frequency.' + (parameter.before | fullFrequency)) | translate }}</span>
                        {{ ('newInvestment.settings.frequency.' + (parameter.after | fullFrequency)) | translate }}
                    } @else {
                        {{ ('newInvestment.settings.frequency.' + (draft().weeksBetweenInvestments | fullFrequency)) | translate }}
                    }
                </div>
            </div>
            <div class="detail-row">
                <div class="label">
                    {{ 'investments.changeDraftCard.composition' | translate }}
                </div>
                <div class="value" data-cy="investment-change-draft-card-composition">
                    {{ (compositionChanged() ? 'investments.changeDraftCard.compositionChanged' : 'investments.changeDraftCard.compositionUnchanged') | translate }}
                </div>
            </div>
            <div class="detail-row">
                <div class="label">
                    {{ 'investments.changeDraftCard.strategyRebalance' | translate }}
                </div>
                <div class="value" data-cy="investment-change-draft-card-rebalance">
                    @if (isStrategy()) {
                        @if (strategyRebalance(); as parameter) {
                            <span class="before">{{ (parameter.before ? 'investments.changeDraftCard.turnedOn' : 'investments.changeDraftCard.turnedOff') | translate }}</span>
                            {{ (parameter.after ? 'investments.changeDraftCard.turnedOn' : 'investments.changeDraftCard.turnedOff') | translate }}
                        } @else {
                            {{ (currentStrategyRebalance() ? 'investments.changeDraftCard.turnedOn' : 'investments.changeDraftCard.turnedOff') | translate }}
                        }
                    } @else {
                        {{ 'investments.changeDraftCard.turnedOn' | translate }}
                    }
                </div>
            </div>
        </div>
    </div>
</a>
